import { onMounted } from "vue";
import { toQueryString } from "./common.mjs";
export function createHeadRecaptcha(params) {
  return () => {
    onMounted(() => {
      const script = document.createElement("script");
      script.src = `https://www.google.com/recaptcha/api.js?${toQueryString(params)}`;
      script.async = true;
      script.defer = true;
      document.head.append(script);
    });
  };
}
